module.exports = __webpack_public_path__ + "static/media/bootstrap-4.d40d337e.svg";